import { createStyles } from "antd-style";

export const useFooterNavigateStyles = createStyles(({ token, css }: any) => ({
  body: css`
    padding-block: 0;

    & > *:not(:first-child) {
      border-top: 1px solid ${token.ColorFigmaNeutralGrayscaleGray40};
    }
  `,
  footer: css`
    display: flex;
    justify-content: space-between;
  `,
  copyright: css`
    padding-block: 32px;
  `,
  help: css`
    padding-block: 16px;
  `,
  menu: css`
    padding-block: 40px;
  `,
}));
